export const HTML_COMMENT_REGEX = /<!--[\s\S]*?-->/g;
export const GOOGLE_DOC_REGEX = /<b.* id="docs-internal-guid-\S*">/i;
